var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "px-0" },
    [
      _c(
        "b-card",
        {
          attrs: {
            "no-body": "",
            "header-tag": "header",
            "footer-tag": "footer",
          },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "d-flex flex-row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "mr-2 text-success task-icon-card-header",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-exchange",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "text-muted task-label-card-header" },
                      [
                        _c("h6", { staticClass: "mb-0 font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.FormMSG(26, "Comments"))),
                        ]),
                      ]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c("task-editor", {
                    attrs: {
                      "task-xid": _vm.keyValue.xid,
                      "reply-to": 0,
                      "image-parent-id": _vm.keyValue.imageParentId,
                    },
                    on: { "task-comment:added": _vm.commentAdded },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "VuePerfectScrollbar",
            {
              ref: "ps-planning-comment",
              style: `height: ${_vm.contentHeight}px`,
              attrs: { settings: _vm.settings },
            },
            [
              _c(
                "b-card-body",
                [
                  _c("task-comment", {
                    attrs: {
                      "key-value": {
                        xid: _vm.keyValue.xid,
                        imageParentId: _vm.keyValue.imageParentId,
                      },
                      "new-comment": _vm.newComment,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }